import ErrorModal from './TimeoutModal'
import './TimeoutModal.css'
export default ErrorModal
